var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('b-card',{attrs:{"title":"Останні події"}})],1),_c('div',{staticClass:"col-12 col-md-6"},[_c('b-card',{attrs:{"title":"Останні події"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }